import { getTokenFromCookies, url } from "../utils/configData";



const fetchTransitionList = async (id, sort) => {
  const end = `/users/${id}/transactions`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const query = `?orderBy=${encodeURIComponent(
      sort.orderBy
    )}&order=${encodeURIComponent(sort.order)}&offset=${encodeURIComponent(
      sort.offset
    )}`;
    const response = await fetch(url + end + query, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchGetInvoice = async (id) => {
  const end = `/invoices/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchScheme = async () => {
  const end = `/transactions/scheme`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }

};

const fetchTransitionListM = async (id, sort) => {
  const end = `/transactions/`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const query = `?orderBy=${encodeURIComponent(
      sort.orderBy
    )}&order=${encodeURIComponent(sort.order)}&offset=${encodeURIComponent(
      sort.offset
    )}`;
    const response = await fetch(url + end + query, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchWalletInfoCrypto = async (id) => {

  const end = `/wallets/crypto/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

const fetchWalletInfoBank = async (id) => {

  const end = `/wallets/bank/${id}`;
  const token = getTokenFromCookies();
  const headers = {
    "Content-Type": "application/json",
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
  try {
    const response = await fetch(url + end, {
      method: "GET",
      credentials: "include",
      headers: headers,
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch user data:", error);
  }
};

export { fetchTransitionList, fetchGetInvoice, fetchScheme, fetchTransitionListM, fetchWalletInfoCrypto, fetchWalletInfoBank };
